<template>
  <div class="booking-search" v-loading.fullscreen="loading">
    <div class="banner-img">
      <img :src="img" alt="banner" v-if="img">
    </div>
    <div class="block">
      <h3>{{ $t('Booking Search') }}</h3>
      <p>
        {{ $t('booking search text') }}
      </p>
      <div class="search-actions">
        <el-form :model="formData" :rules="rules" ref="searchForm" :inline="true">
          <el-form-item class="input-row" prop="confirmation_number">
            <el-input v-model="formData.confirmation_number" :placeholder="$t('Your 9 digits confirmation number...')"/>
          </el-form-item>
          <i class="el-icon-plus"></i>
          <el-form-item class="input-row" prop="last_name">
            <el-input :placeholder="$t('Your Last Name...')" v-model="formData.last_name"/>
          </el-form-item>
          <el-button type="primary" @click.prevent="search('searchForm')">{{ $t('SEARCH') }}</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data: function () {
    return {
      formData: {
        confirmation_number: '',
        last_name: '',
      },
      rules: {
        confirmation_number: [
          {required: true, message: this.$t('Confirmation number is require'), trigger: 'change'}
        ],
        last_name: [
          {required: true, message: this.$t('Last name is require'), trigger: 'change'}
        ]
      },
      img: '',
      loading: false
    }
  },
  methods: {
    search(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.axios.get('/api/group/order/search',
            {
              params: this.formData,
              headers:{
                Currency:'MOP',
              }
            }
          ).then((res) => {
                if (res.code !== 200) {
                  this.$alert(this.$t(res.msg), this.$t('no-room title'), {
                    confirmButtonText: this.$t('CLOSE'),
                    center: true,
                }).then(() => {
                  this.loading = false
                }).catch(e => e)

                } else {
                  this.$router.push({
                    'name': 'Information',
                    query: {
                      ...this.formData,
                      'skin': this.skin
                    },
                    params: res.data
                  })
                }
              }
            ).finally(() => {
              this.loading = false
            })
        }
      });
    },
    getImg() {
      this.axios.get('api/group/info/search-img').then((res) => {
        this.img = res.data.img
      })
    },
  },
  created() {
    this.getImg()
  }
}

</script>
